import React from 'react';
import { Attachments } from 'components';
import { useParams } from 'react-router-dom';
import { useAccessControl } from 'components/common/accessControl/useAccessControl';
import { PERMISSIONS } from 'constants/permissions';

export const UserAttachments = React.memo(() => {
  const { id } = useParams() as { id: string };
  const { hasAccess } = useAccessControl();
  return (
    <Attachments
      entityId={id}
      entityName={'ADMIN'}
      service={'uaa'}
      hasAccessToWrite={hasAccess(PERMISSIONS.users.attachment.write)}
      hasAccessToDelete={hasAccess(PERMISSIONS.users.attachment.delete)}
    />
  );
});
